import React from 'react';
import { useParams } from 'react-router-dom';
import BookingFormPage from './BookingFormPage';

const BookingEditPage = () => {
  const { id } = useParams();
  return <BookingFormPage id={id} />;
};

export default BookingEditPage;
